<template>
    <ThemeSwitcher />
    <div class="card">
        <Chart type="bar" :data="chartData" :options="chartOptions" />
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Chart from "primevue/chart";
//import api from "@/utils/axios";


onMounted(async() => {
    //chartData.value = setChartData();
    //chartOptions.value = setChartOptions();
    chartOptions.value = setChartOptions();
    await getTopCustomerData();
});

const chartData = ref(null);
const chartOptions = ref(null);

const getTopCustomerData = async () => {
    try {
        //const response = await api.get('/report/topcustomerreport');
        //console.log(response);
        //const rawData = response.data;
        //console.log('28');
        //console.log(rawData);
        //const labels = rawData.map(item => item.user_fullname)
       // const spentValues = rawData.map(item => Math.round(item.total_sales));

        chartData.value = {
                labels: ['John', 'Sam', 'Mary', 'Peter'],
                datasets: [
                    {
                        label: ['John', 'Sam', 'Mary', 'Peter'],
                        data: [2000,3000,4000,5000],
                        backgroundColor: ['rgba(249, 115, 22, 0.2)', 'rgba(6, 182, 212, 0.2)', 'rgb(107, 114, 128, 0.2)', 'rgba(139, 92, 246 0.2)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'],
                        borderColor: ['rgb(249, 115, 22)', 'rgb(6, 182, 212)', 'rgb(107, 114, 128)', 'rgb(139, 92, 246)', 'rgba(75, 192, 192, 0.2)', 'rgba(153, 102, 255, 0.2)'],
                        borderWidth: 1
                    }
                ]
            };
    } catch (error){
        console.error("API 讀取失敗:", error);
    }
}

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

    return {
        plugins: {
            legend: {
                display: false,
            },
                title: {
                    display: true,
                    text: 'Top Customer Spending',
                    color: textColor,
                    font: {
                        size: 16,         
                        weight: 'bold',   
                        family: 'Arial'   
                    } 
                }
            },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            }
        }
    };
}
</script>